import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { PAYROLL_API } from "../constants/constants";
import { defaultErrorMsg, defaultHeaders } from "../utils/params";

export const payrollServiceApi = createApi({
  reducerPath: "payrollServiceApi",
  baseQuery: async (args, api, extraOptions) => {
    const baseQuery = fetchBaseQuery({
      baseUrl: PAYROLL_API,
      prepareHeaders: async (headers, { getState }) => {
        const token = (getState() as any)?.auth?.access_token;

        return defaultHeaders(headers, token);
      },
    });

    const result = await baseQuery(args, api, extraOptions);

    await defaultErrorMsg(result);

    return result;
  },
  tagTypes: [
    "GetEmployeeBreakdownSalaryDetails",
    "GetPayrollSetting",
    "GetMonthlyPayCycle",
    "GetSalarySummary",
    "GetSalaryReport",
    "GetTaxData",
    "GetOvertime",
    "GetPayComponentSetting",
    "GetVariableSalary",
    "GetAdditionDeductionSalary",
    "GetOvertimeSalary",
    "GetHolidayAllowance",
    "GetHolidayAllowanceSetting",
    "GetVariableSalaryId",
    "GetAdditionDeductionId",
    "GetOvertimeExcelId",
    "GetHolidayAllowanceId",
    "GetTaskQueue",
  ],
  keepUnusedDataFor: 2,
  endpoints: () => ({}),
});
